import { Slider as MuiSlider } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import { colorUsage } from 'stylesheetB2c';

import {
  CONTROLS_BACKGROUND_OVERLAY_Z_INDEX,
  SLIDER_HEIGHT,
} from '../DesktopControls/DesktopControls.style';

interface BufferedTrackProps {
  start: number;
  end: number;
  songDuration: number;
}

const RAIL_Z_INDEX = 1;
const BUFFERED_TRACK_Z_INDEX = RAIL_Z_INDEX + 1;
const PROGRESS_TRACK_AND_THUMB_Z_INDEX = BUFFERED_TRACK_Z_INDEX + 1;
export const TIME_SLIDER_Z_INDEX = CONTROLS_BACKGROUND_OVERLAY_Z_INDEX + 1;

export const TimeSliderContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${SLIDER_HEIGHT};
  display: flex;
  align-items: center;
  z-index: ${TIME_SLIDER_Z_INDEX};
`;
TimeSliderContainer.displayName = 'TimeSliderContainer';

export const CustomSliderRail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${colorUsage.mp3KbpPlayer.sliderRailColor};
  z-index: ${RAIL_Z_INDEX};
`;
CustomSliderRail.displayName = 'CustomSliderRail';

export const BufferedTrack = styled.div<BufferedTrackProps>`
  position: absolute;
  top: 0;
  left: ${(props) => `${(props.start / props.songDuration) * 100}%`};
  height: 100%;
  width: ${(props) => `${((props.end - props.start) / props.songDuration) * 100}%`};
  background-color: ${colorUsage.mp3KbpPlayer.bufferedTracksColor};
  z-index: ${BUFFERED_TRACK_Z_INDEX};
`;
BufferedTrack.displayName = 'BufferedTrack';

export const Slider = muiStyled(MuiSlider)(() => ({
  root: {
    width: '100%',
  },
  track: {
    height: SLIDER_HEIGHT,
    backgroundColor: colorUsage.mp3KbpPlayer.sliderTrackAndThumbColor,
    zIndex: PROGRESS_TRACK_AND_THUMB_Z_INDEX,
  },
  thumb: {
    backgroundColor: colorUsage.mp3KbpPlayer.sliderTrackAndThumbColor,
    zIndex: PROGRESS_TRACK_AND_THUMB_Z_INDEX,
  },
  rail: {
    display: 'none',
  },
}));
